import { GPTGameButton } from './GPTGameButton';
import { GptGameButtonProps } from '../types';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/modules/gpt/games';
import { CardEventIcon } from './GPTEventIcons/CardEventIcon';

export const LuckyCardButton = ({ isCollapsed, isEventActive }: GptGameButtonProps) => {
  const { startRegistration } = useAuthFlow();

  return (
    <GPTGameLauncher
      gameName="cardGame"
      renderButton={({ Icon, ...props }) => (
        <GPTGameButton
          {...props}
          Icon={isEventActive ? CardEventIcon : Icon}
          isCompact={isCollapsed}
        />
      )}
      openRegistration={startRegistration}
    />
  );
};
